<template>
  <div>
    <b-sidebar
      id="sidebar-right"
      v-model="pdfShow"
      :right="right"
      backdrop
      shadow
      no-header
      :no-close-on-backdrop="backdropNoClose"
    >
      <div class="px-8  pb-0">
        <b-overlay blur="50px" :show="pdfLoading" rounded="sm" :opacity="0.95">
          <b-row>
            <b-col cols="12" class="px-8 mb-2 d-flex justify-content-between">
              <div class="w-100">
                <slot name="buttons"></slot>
              </div>
              <b-button
                @click="pdfShow = false"
                variant="light"
                class="mt-2 mr-4"
              >
                <i class="fa fa-times"></i>
              </b-button>
            </b-col>
            <b-col>
              <div class="bg-white px-3 " style="min-height: 70vh">
                <embed
                  width="100%"
                  v-if="base64"
                  :src="`data:application/pdf;base64,${base64}`"
                  :style="`min-height:calc(100vh - 80px); background-color: #ffffff`"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                />
              </div>
            </b-col>
          </b-row>
        </b-overlay>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import Service from "@/services/vacancy.service";
export default {
  props: {
    bodyHtml: {
      default: "",
      type: String,
    },
    right: {
      default: true,
      type: Boolean,
    },
    backdropNoClose: {
      default: false,
      type: Boolean,
    },
    landscape: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      base64: null,
      pdfShow: false,
      pdfLoading: false,
    };
  },
  methods: {
    async viewPdf() {
      this.pdfShow = true;
      this.pdfLoading = true;
      let res = await Service.viewPdf({
        body: this.bodyHtml,
      });
      this.base64 = res.data;

      this.pdfLoading = false;
    },
    async downloadPdf(bodyHtml) {
      let action = "viewPdf";
      let res = await Service[action]({
        body: bodyHtml,
      });
      return new Promise((resolve, reject) => {
        try {
          const linkSource = `data:application/pdf;base64,${res.data}`;
          const downloadLink = document.createElement("a");
          const fileName = `Javob xati.pdf`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          resolve(res.data);
        } catch (e) {
          reject(e);
        }
      });
    },
    async viewPdfArg(bodyHtml, margin = "") {
      this.pdfShow = true;
      this.pdfLoading = true;
      let payload = ` <html>
            <head>
                <style>
                    @page {
                      ${margin} !important;
                    }
                </style>
            </head>
            <body>
                ${bodyHtml}
            </body>
        </html> 
        `;
      let res = await Service.viewPdf({
        body: payload,
      });
      this.base64 = res.data;

      this.pdfLoading = false;
    },
    show() {
      this.pdfShow = true;
      this.pdfLoading = true;
    },
    close() {
      this.pdfShow = false;
      this.pdfLoading = false;
    },
  },
};
</script>

<style>
.status {
    position: relative;
    z-index: 999;
}
#sidebar-right {
  min-width: 1000px;
  max-width: 100%;
  z-index: 999999;
}
#sidebar-right .b-sidebar-body {
    overflow-x: hidden;
}
.top0 #sidebar-right {
  top: 0;
}
</style>